import {
    useMutation,
    useQueryClient,
} from '@tanstack/react-query'
import { useJWTToken } from 'App/Auth'

import QUERY_KEYS from 'shared/utils/queryKeys'
import { completeProcess } from '../services/process'

function useCompleteProcess() {
    const token = useJWTToken()
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: ({ processId }) => {
            return completeProcess(token, processId)
        },
        onSuccess: () => {
            queryClient.invalidateQueries(QUERY_KEYS.Asset)
        },
        throwOnError: true,
    })
}

export default useCompleteProcess
